import React, { useEffect } from "react";
import Fade from "react-reveal/Fade";
import firstBlog from "../images/image-34.png";
import image35 from "../images/image-35.png";
import image36 from "../images/image-36.png";

import image40 from "../images/image-40.png";

export default function Blog9Ar() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div class="page-title">
        <div class="container">
          <Fade top duration={1000} delay={500}>
            {" "}
            <h1
              style={{
                color: "#C0AB89",
                fontFamily: "Millania",
                fontSize: "60px",
              }}
            >
              مدونه
            </h1>
          </Fade>

          {/* <h1>Blog</h1> */}
        </div>
      </div>
      <section>
        <div className="container p-5">
          <div
            className="row"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div className="col-md-8">
              <h1 style={{ color: "#C0AB89", fontFamily: "Maya" }}   dir="rtl" lang="ar">
              الاستدامة في معالجة المنسوجات

              </h1>
            </div>
            <div className="col-md-8">
              <h5   dir="rtl" lang="ar">مقدمة:</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"   >"تساهم صناعة الملابس بما يصل إلى 10٪ من التلوث الذي يؤدي إلى أزمة المناخ." ظهر هذا الادعاء في منشور على Instagram نشرته شركة الملابس باتاغونيا في أواخر نوفمبر 2020 ، وحصل على أكثر من 502,000 مشاهدة. على الرغم من أن المنشور لا يشير إلى مصدر الادعاء ، إلا أن الدراسات العلمية تقدر أن الملابس تساهم بنسبة 3 إلى 10٪ من انبعاثات غازات الدفيئة التي تؤدي إلى تغير المناخ (Hertwich and Peters ، 2009).
              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"   >
            واحدة من أكثر الصناعات تلويثا هي المنسوجات والملابس. وتنتج بصمتها البيئية الضارة عن الاستخدام العالي للطاقة والمياه والمواد الكيميائية ، وتوليد نفايات المنسوجات والألياف الدقيقة التي تتساقط في البيئة أثناء الغسيل (Niinimäki et al. ، 2020). علاوة على ذلك ، تشير التقديرات إلى أن ما يصل إلى 20٪ من تلوث مياه الصرف الصناعي ناتج عن صباغة المنسوجات والتشطيب (Morlet et al. ، 2017).
              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
             الآثار البيئية لصناعة الأزياء واسعة النطاق وكبيرة. على سبيل المثال ، على الرغم من وجود مجموعة من التقديرات ، تنتج الصناعة 8-10٪ من انبعاثات ثاني أكسيد الكربون العالمية (4-5 مليارات طن سنويا). تعد صناعة الأزياء أيضا مستهلكا رئيسيا للمياه (79 تريليون لتر سنويا) ، وهي مسؤولة عن ~ 20٪ من تلوث المياه الصناعية من معالجة المنسوجات والصباغة ، وتساهم ~ 35٪ (190000 طن سنويا) من التلوث الأولي للبلاستيك الأولي في المحيطات 1 وتنتج كميات هائلة من نفايات المنسوجات (>92 مليون طن سنويا) ، ينتهي الكثير منها في مكب النفايات أو يتم حرقها ،  بما في ذلك المنتج غير المباع. يمكن أن يعزى التأثير البيئي المتزايد (والوعي به) إلى الزيادة الكبيرة في استهلاك الملابس ، وبالتالي إنتاج المنسوجات. فعلى سبيل المثال، ارتفع نصيب الفرد من الإنتاج العالمي من المنسوجات من 5.9 كيلوغرام إلى 13 كيلوغراما سنويا خلال الفترة 1975-2018. وبالمثل، ارتفع الاستهلاك العالمي إلى ما يقدر بنحو 62 مليون طن من الملابس سنويا، ومن المتوقع أن يصل إلى 102 مليون طن بحلول عام 2030. ونتيجة لذلك ، تنتج ماركات الأزياء الآن ما يقرب من ضعف كمية الملابس اليوم مقارنة بما كان عليه الحال قبل عام 2000.
              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
                في عام 1975 ، تم إنتاج حوالي 34 مليون طن متري من ألياف النسيج في جميع أنحاء العالم. بحلول عام 2020 ، تضاعفت هذه الكمية بأكثر من ثلاثة أضعاف ، لتصل إلى 109 مليون طن متري وكان من المتوقع أن تصل إلى 146 مليون طن متري بحلول عام 2030 (https://www.statista.com/statistics/1250985/global-textile-fiber-production/).
              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"   >
            ومع ذلك ، فإن صناعات النسيج هي العمود الفقري للحضارة الإنسانية. وبالتالي ، تبذل كل الجهود لتحسين استدامتها. إن استخدام مواد النسيج الصديقة للبيئة والأصباغ والمواد الكيميائية ، وتكييف العمليات الجديدة والمحسنة مع ضوابط صارمة للعملية ، والصباغة بدون ماء هي بعض الطرق التي يمكن من خلالها تحسين الاستدامة.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"   >
              ومع ذلك ، فإن صناعات النسيج هي العمود الفقري للحضارة الإنسانية. وبالتالي ، تبذل كل الجهود لتحسين استدامتها. إن استخدام مواد النسيج الصديقة للبيئة والأصباغ والمواد الكيميائية ، وتكييف العمليات الجديدة والمحسنة مع ضوابط صارمة للعملية ، والصباغة بدون ماء هي بعض الطرق التي يمكن من خلالها تحسين الاستدامة.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
               عند النظر في كل من الحجم المتولد وتكوين النفايات السائلة ، تعتبر مياه الصرف الصحي النسيجية أكثر المياه تلوثا بين جميع القطاعات الصناعية. سلسلة توريد المنسوجات العالمية معقدة للغاية ، وتشمل العديد من المراحل المتغيرة. لذلك ، قد تكون الشركات وأصحاب العلامات التجارية في أفضل وضع لإحداث التغيير المطلوب.
              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
              يتم إطلاق المياه المشحونة بالمواد الكيميائية كمياه صرف صحي ، والتي ، إذا لم تتم معالجتها جيدا ، قد تلوث البيئة حراريا بسبب ارتفاع درجة حرارة النفايات السائلة ، وكيميائيا بسبب ظروف الأس الهيدروجيني القاسية و / أو التلوث بالأصباغ ، ومخففات الأصباغ ، والمواد المساعدة ، والمبيضات ، والمنظفات ، والإشراقات البصرية والعديد من المواد الكيميائية الأخرى بما في ذلك المعادن الثقيلة المسببة للسرطان المستخدمة أثناء معالجة المنسوجات.

              </p>
              <h5   dir="rtl" lang="ar">الاستدامة:</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
              وينبغي أن تكون المنسوجات المستدامة مراعية للبيئة وأن تفي بالشروط الرشيدة لاحترام الجودة الاجتماعية والبيئية عن طريق منع التلوث من خلال مختلف تكنولوجيات مكافحة التلوث.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"   >
           الشهادة البيئية هي عملية طوعية. يجوز لأي كيان يدير نشاطا تجاريا يوجد له معيار أن يطلب اعتماد مخرجاته أو خدماته. الشهادة هي إجراء يقدم من خلاله طرف ثالث ، هيئة إصدار الشهادات ، تأكيدا كتابيا بأن النظام التنظيمي أو العملية أو الشخص أو المنتج أو الخدمة يتوافق مع المتطلبات المحددة في معيار أو معيار. يتم منح الشهادة لفترة محدودة ، تقوم خلالها هيئة إصدار الشهادات بالمراقبة. أصدرت هيئات إصدار الشهادات والحكومات التابعة لجهات خارجية قوائم المواد المحظورة التي تربط بيئة الإنتاج بالبيئة البشرية (Oecotextiles ، 2012).
              </p>
              <h5   dir="rtl" lang="ar">ستة قضايا للاستدامة:
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
             القضايا الست التالية لديها القدرة على جعل دورات حياة المنسوجات والملابس غير مستدامة (شيربورن ، 2009):

              </p>
              <ul className="dot-list"   dir="rtl" lang="ar">
                <li>استخدام المواد الكيميائية السامة
</li>
                <li>استهلاك المياه</li>
                <li>استهلاك الطاقة</li>
                <li>توليد النفايات</li>

                <li>النقل</li>
                <li>مواد التعبئة والتغليف</li>
              </ul>
              <h5   dir="rtl" lang="ar">1.استخدام المواد الكيميائية السامة</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
            العديد من الأصباغ والمواد الكيميائية المستخدمة في صناعة النسيج سامة وغير صديقة للبيئة. يتم استخدام عدد كبير من الأصباغ في صباغة وطباعة المنسوجات. يسرد مؤشر الألوان الدولي 27000 منتج فردي تحت 13000 اسم عام لمؤشر الألوان (SDC ، 2016). تشكل المواد الكيميائية المتطايرة مشاكل خاصة لأنها تتبخر في الهواء أو يتم امتصاصها في الأطعمة أو من خلال الجلد. بعض المواد الكيميائية مسرطنة أو بعضها ضار للأطفال حتى قبل الولادة ، في حين أن البعض الآخر قد يؤدي إلى ردود فعل تحسسية لدى بعض الأشخاص.
              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
            تتغير قوائم المواد المحظورة باستمرار مع توفر المزيد من المعلومات من العلماء والمهنيين الصحيين ، مما يؤدي إلى فهم معزز للمواد الكيميائية وتأثيرها على صحة الإنسان والبيئة. تستند المواد المدرجة في قائمة المواد المحظورة (RSL) إلى حد كبير إلى التشريعات العالمية التي تنظم استخدام المواد الكيميائية في تصنيع منتجات الملابس. طور الاتحاد الأوروبي المنظمة وهي "اللائحة المتعلقة بتسجيل وتقييم وترخيص وتقييد المواد الكيميائية" أو "REACH" والتي تهدف إلى ضمان مستوى عال من حماية صحة الإنسان والبيئة من المخاطر التي يمكن أن تشكلها المواد الكيميائية (AAFA ، 2016).
              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
              الدول الأخرى التي وضعت قوائم مماثلة للمواد المحظورة هي الصين وكندا وكوريا الجنوبية. في الولايات المتحدة ، تبنت عدة ولايات ، بما في ذلك كاليفورنيا وواشنطن وماين ، قوانين تنظم المواد الكيميائية في المنتجات الاستهلاكية. يتم دمج هذه المتطلبات التنظيمية في RSL.
              </p>{" "}
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
                {" "}
                في 7 يونيو 2018 ، وضعت "وكالة حماية البيئة (EPA)" ، الولايات المتحدة الأمريكية اللمسات الأخيرة على قاعدة تضيف فئة من 13 إيثوكسيلات نونيلفينول محددة (NPEs) إلى قائمة جرد إطلاق السموم (TRI) للمواد الكيميائية التي يجب الإبلاغ عنها. NPEs هي مواد خافضة للتوتر السطحي غير أيونية تستخدم في المواد اللاصقة ، وعوامل الترطيب ، والمستحلبات ، والمثبتات ، والمشتتات ، ومزيلات الرغوة ، والمنظفات ، والدهانات ، والطلاء. يتحلل NPE في البيئة إلى مواد بما في ذلك nonylphenol (NP) ، الذي يتراكم في أجسام الأسماك ويعطل هرموناتها ، مما يضر بالخصوبة والنمو والتطور الجنسي. تم حظر استخدام NPE في صناعة المنسوجات في أوروبا منذ أكثر من 10 سنوات ولكن لا يزال يتم إطلاق المادة في البيئة المائية من خلال غسل المنسوجات المستوردة. وافقت الدول الأعضاء في الاتحاد الأوروبي على حظر هرمون تعطيل NPE الموجود على نطاق واسع في الملابس لأنه يشكل "خطرا غير مقبول" على البيئة (The Guardian ، 2015).
              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"   >
         يتم استخدام إنزيمات مختلفة لاستبدال عدد من المواد الكيميائية الخطرة في صناعة النسيج. ارتفع السوق العالمي للإنزيمات الصناعية من 1.5 مليار دولار أمريكي في عام 2000 إلى 2.25 مليار دولار أمريكي في عام 2007 (روي تشودري ، 2014).
              </p>
              <h5   dir="rtl" lang="ar">2.  استهلاك المياه</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
             بعد الزراعة ، تعتبر المنسوجات والصناعات ذات الصلة ثاني أكبر مستهلك وملوث للمياه النظيفة (Oecotextiles ، 2012). يستخدم الماء في العديد من خطوات عملية صباغة المنسوجات لنقل المواد الكيميائية المستخدمة أثناء الخطوة ولغسلها قبل البدء في الخطوة التالية. في عملية الصباغة والتشطيب التقليدية على سبيل المثال ، يمكن أن يؤدي طن واحد من القماش إلى تلوث ما يصل إلى 200 طن من المياه بواسطة مجموعة من المواد الكيميائية الضارة وفي هذه العملية يستهلك كميات كبيرة من الطاقة للبخار والماء الساخن (Moore and Wentz ، 2009). مع تركز الصناعة الآن في البلدان التي لا تزال لديها أنظمة تنظيمية بيئية قيد التطوير ، مثل الصين والهند وبنغلاديش وفيتنام ، لا يزال تصنيع المنسوجات له بصمة بيئية ضخمة.
              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"   >
           يمكن أن توفر إعادة استخدام مياه الصرف الصحي وفورات مهمة للغاية ، أي في الحد من استهلاك المياه والطاقة والمواد الكيميائية. تتأثر إعادة تدوير مياه الصرف الصحي في حمامات المعالجة ومياه الشطف ، قبل أخذ المياه للمعالجة لإزالة المواد الكيميائية المتبقية والنفايات السائلة الأخرى المتولدة. يمكن استرداد مكثفات البخار ومياه التبريد بسهولة لأنها نظيفة. يمكن لطاقتهم الحرارية أن تسدد الاستثمار بسرعة كبيرة.
              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar">
      مع النمو المستمر للإنتاج والاستهلاك العالميين للمنتجات والخدمات المتعلقة بالمنسوجات ، هناك فرص وتحديات لصناعة النسيج.

              </p>
              <h5   dir="rtl" lang="ar">3. استهلاك الطاقة</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
            صناعة النسيج هي صناعة رئيسية مستهلكة للطاقة مع كفاءة منخفضة في استخدام الطاقة. يتم استهلاك حوالي 23 ٪ من إجمالي الطاقة في النسيج ، و 34 ٪ في الغزل ، و 38 ٪ في المعالجة الكيميائية و 5 ٪ أخرى لأغراض متنوعة. تهيمن الطاقة الحرارية على المعالجة الكيميائية بينما تهيمن الطاقة الكهربائية على نمط استهلاك الطاقة في الغزل والنسيج. يتم استهلاك الطاقة الحرارية في مصانع النسيج بشكل أساسي لتسخين المياه وتجفيف المواد النسيجية (Rupp J. 2008).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
             صناعة النسيج هي واحدة من أكبر مصادر غازات الدفيئة (GHG's) ، لأسباب ليس أقلها حجمها الهائل. في عام 2008 ، قدر الإنتاج العالمي السنوي للمنسوجات بنحو 60 مليار كيلوغرام من النسيج مع احتياجات الطاقة والمياه المرتبطة بها (المقدرة) البالغة 1074 مليار كيلوواط ساعة من الكهرباء (أو 132 مليون طن من الفحم) وما بين 6 إلى 9 تريليونات لتر من المياه (Oecotextiles ، 2011).
              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"   >
           يتم استهلاك كمية كبيرة من مصادر الطاقة غير المتجددة في نهاية المطاف في شكل كهرباء ، ليس كثيرا في عملية إنتاج المنسوجات (15-20٪) ولكن في الغالب في عمليات الغسيل اللاحقة أثناء استخدام المستهلك (75-80٪) (شيربورن ، 2009). يذكر (Ray and Reddy، 2008) أن إجمالي الطاقة الحرارية المطلوبة لكل متر من القماش هو 18.8-23 ميجا جول والطاقة الكهربائية المطلوبة لكل متر من القماش هي 0.45-0.55 كيلو واط ساعة. يتم استهلاك الطاقة المستخدمة في الغالب عن طريق تسخين مياه المعالجة أو لاستخدامها في غسل وتجفيف المواد بعد الغسيل. في حين أن البيانات المتعلقة باستخدام الطاقة لصناعة النسيج متاحة بسهولة ، تنشأ تعقيدات في تقدير انبعاثات CO2 المرتبطة التي تنشأ من المصادر (الفحم أو الكهرباء أو الغاز الطبيعي أو مصادر أخرى) التي يتم إنتاج الطاقة منها لأن صناعة النسيج هي قطاع مجزأ وغير متجانس تهيمن عليه الشركات الصغيرة والمتوسطة (SMEs).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
              الطاقة هي واحدة من عوامل التكلفة الرئيسية في صناعة النسيج. خاصة في أوقات التقلبات العالية في أسعار الطاقة ، يجب أن يكون تحسين كفاءة الطاقة مصدر قلق رئيسي لمصانع النسيج وتوجد فرص مختلفة لكفاءة الطاقة في كل مصنع نسيج ، وكثير منها فعال من حيث التكلفة ، ولكن لا يتم تنفيذه بسبب المعلومات المحدودة أو التكلفة الأولية العالية. على سبيل المثال ، يرتبط استخدام الكهرباء بأوجه القصور المدمجة مقارنة بالاستخدام المباشر للطاقة الحرارية واستخدام البخار أقل كفاءة من تسخين الغاز المباشر في المطحنة. تعتمد حصة إجمالي الطاقة الصناعية التي تستهلكها صناعة النسيج في بلد معين على هيكل قطاع التصنيع في ذلك البلد. على سبيل المثال ، تمثل صناعة النسيج حوالي 4٪ من الاستخدام النهائي للطاقة في التصنيع في الصين (LBNL ، 2007) ، في حين أن هذه الحصة أقل من 2٪ في الولايات المتحدة الأمريكية (وزارة الطاقة الأمريكية ، 2010).
              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
               الكهرباء هي الطاقة الرئيسية المستهلكة في صناعة النسيج ، وتستخدم لآلات القيادة والتبريد والتحكم في درجة الحرارة والإضاءة والمعدات المكتبية ، في حين أن زيت الوقود وغاز البترول المسال والفحم وغاز المدينة تستخدم على نطاق واسع لتوليد البخار. وقد تحققت أوجه الكفاءة؛ بين عامي 1990 و 2005 ، انخفضت كثافة انبعاثات الكربون في صناعة النسيج للقماش الرمادي وسلع الجوت ورقائق البوليستر بنسبة 1.90 و 2.07 و 0.72 في المائة على التوالي. من ناحية أخرى ، أظهر غزل القطن أعلى زيادة في كثافة الانبعاثات بنسبة 7.37٪ ، مما يعني أن خيوط القطن لا تزال تنتج بشكل غير فعال (ECCJ ، 2007). كثافة الانبعاثات هي متوسط معدل انبعاثات ملوث معين من مصدر معين بالنسبة إلى شدة نشاط معين ؛ على سبيل المثال جرامات ثاني أكسيد الكربون المنبعثة لكل ميجا جول من الطاقة المنتجة ، أو نسبة انبعاثات غازات الدفيئة المنتجة إلى الناتج المحلي الإجمالي. تستخدم كثافة الانبعاثات لاشتقاق تقديرات لانبعاثات ملوثات الهواء أو غازات الدفيئة بناء على كمية الوقود المحترق ، وعدد الحيوانات في تربية الحيوانات ، ومستويات الإنتاج الصناعي ، والمسافات المقطوعة أو بيانات النشاط المماثلة. ويمكن أيضا استخدام كثافة الانبعاثات لمقارنة الأثر البيئي لمختلف أنواع الوقود أو الأنشطة. غالبا ما يتم استخدام المصطلحين ذوي الصلة عامل الانبعاثات وكثافة الكربون بالتبادل ، لكن "العوامل" تستبعد الأنشطة الإجمالية مثل الناتج المحلي الإجمالي ، و "الكربون" يستبعد الملوثات الأخرى (ويكيبيديا 2013).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
           يستهلك الغزل أكبر حصة من الكهرباء (41٪) يليه النسيج (بما في ذلك إعداد النسيج) (18٪) بينما يستهلك تحضير المعالجة الرطبة (الإزالة ، التبييض) والتشطيب معا أكبر حصة من الطاقة الحرارية (35٪). يتم أيضا فقدان كمية كبيرة من الطاقة الحرارية أثناء توليد البخار وتوزيعه (35٪) ، لكن هذه النسب ستختلف حسب المصنع. يشير هذا التحليل لفرص تحسين كفاءة الطاقة في صناعة النسيج إلى المزايا التي يمكن اكتسابها من التعديل التحديثي / تحسين العملية ، وليس فقط من الاستبدال الكامل للآلات الحالية بأحدث التقنيات الجديدة (حسن بيجي ، 2010).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar">
            هناك إمكانيات مختلفة لاستخدام الطاقة المتجددة في صناعة النسيج. أربعة أمثلة من مجموعة من التدابير الممكنة هي:

              </p>
              <ul className="dot-list"   dir="rtl" lang="ar">
                <li>
                تركيب مراوح توربو تعمل بالرياح على أسطح مصانع الإنتاج ؛

                </li>
                <li>استخدام الطاقة الشمسية المباشرة لتجفيف الألياف ؛ و
</li>
                <li>
                استخدام الطاقة الشمسية لتسخين المياه في صناعة النسيج ؛

                </li>
                <li>توليد الكهرباء بالطاقة الشمسية
</li>
              </ul>
              <h5   dir="rtl" lang="ar">4. توليد النفايات
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"   >
             مثل أي صناعة أخرى ، تولد صناعة النسيج جميع فئات النفايات الصناعية وهي السوائل والمواد الصلبة والغازات. بالنسبة للعمليات الأكثر اخضرارا ، يجب إعادة تدوير النفايات غير المتجددة والنفايات المتجددة إلى سماد إذا لم تكن إعادة التدوير خيارا. يمكن استرداد العديد من المواد المفيدة من نفايات عملية النسيج.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"   >
       يمكن تحقيق استعادة المواد الكيميائية مثل هيدروكسيد الصوديوم من حمامات الميرسيرس عن طريق التسخين لتركيز المحلول. بعد هذه الخطوة ، يمكن استرداد 90٪ من هيدروكسيد الصوديوم (Indiamart ، 2013). يستعيد نظام شفط الفراغ EVAC في عملية صباغة المنسوجات بيروكسيد الهيدروجين القلوي الساخن والمواد المضافة والمواد الكيميائية النهائية (TIFAC (DST) ، 2012). EVAC هو الاسم التجاري لنظام الفراغ الذي تم تقديمه في تايلاند من الولايات المتحدة. يتم تركيب هذه المعدات في مرحلة التشطيب لامتصاص المحلول الكيميائي الزائد من النسيج ، ثم نقله إلى خزان التخزين لاستعادته وإعادة تدويره (برنامج الأمم المتحدة للبيئة ، 1994).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
              إن إزالة النفايات السائلة التي تحتوي على كحول البولي فينيل (PVA) له طلب مرتفع على الأكسجين الكيميائي (COD) ، وبالتالي ، يساهم بشكل كبير في عملية معالجة الأوكسجين الأولية للمياه (POTW) في مصنع النسيج ، وكونه خاملا بيولوجيا ، فإنه يمثل تهديدا للبيئة. لسوء الحظ ، لم يتم تنفيذ أي وسيلة فعالة وفعالة لمعالجة النفايات السائلة التي يتم تغيير حجم PVA في صناعة النسيج. يبلغ عمر تقنية التناضح العكسي للترشيح الفائق (UF) لاستعادة وإعادة تدوير حجم PVA أكثر من 40 عاما ، ولكنها لا تستخدم على نطاق واسع بسبب عيوبها العديدة. يتطلب الوضع تقنية جديدة لاستعادة وإعادة تدوير حجم PVA والتي يمكن أن تقلل من استهلاك الطاقة والمياه بطريقة اقتصادية وصديقة للبيئة. التكنولوجيا الجديدة التي من شأنها القضاء على عيوب عملية الترشيح الفائق الحالية في استعادة PVA من النفايات السائلة ذات الحجم المنخفض هي تبخر فلاش الفراغ (VFE). تم استخدام عملية VFE للاسترداد والتركيز في مجموعة متنوعة من الصناعات الأخرى ، ولكن لم يتم إثباتها مطلقا لاستعادة الحجم في صناعة النسيج (Gupta ، 2009).

              </p>
              <h5   dir="rtl" lang="ar">ملوثات مياه الصرف الصحي
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
              لا يزال يتم التخلص من بعض مياه الصرف الصحي بطريقة غير صديقة للبيئة ، في شبكات الصرف الصحي حيثما كانت متاحة ، أو في البالوعات ، دون اعتبار للطلب على الأكسجين الكيميائي الحيوي (BOD) ، والطلب على الأكسجين الكيميائي (COD) و / أو محتوى المعادن الثقيلة في مياه الصرف الصحي. يمكن أن تختلف مياه الصرف الصحي غير المعالجة الناتجة عن إنتاج المنسوجات ومعالجتها اختلافا كبيرا اعتمادا على المواد الكيميائية وعمليات المعالجة المعنية وقد تشمل المواد ذات BOD و COD العالي ، والمواد الصلبة العالقة الكلية العالية ، والزيوت والشحوم ، والكبريتيدات ، والكبريتات ، والفوسفات ، والكروم ، والنحاس و / أو أملاح المعادن الثقيلة الأخرى (TFL Ledertechnik AG ، 2016) من هذه ،  يعتبر أهمها COD (الطلب على الأكسجين الكيميائي) ، BOD (الطلب على الأكسجين الكيميائي الحيوي) ، درجة الحموضة ، الدهون ، الزيت ، النيتروجين ، الفوسفور ، الكبريتات و SS (المواد الصلبة العالقة) (Tüfekci et al. ، 2007). مستويات المواد الصلبة العالقة (TSS) منخفضة في مياه الصرف الصحي لصباغة المنسوجات الخام مقارنة بالعديد من الصناعات الأخرى. من ناحية أخرى ، فإن الطلب على الأكسجين الكيميائي الحيوي (BOD) والطلب على الأكسجين الكيميائي (COD) مرتفعان نسبيا في النفايات السائلة الناتجة عن عمليات التحجيم ، وبالتالي ، تعد المعالجة الرطبة أهدافا أكثر أهمية لمنع التلوث (Visvanathan et al. ، 2000). الكبريتات والفوسفات سامة بتركيزات عالية جدا. غالبا ما ترتبط المشاكل التي تسببها الكبريتات بقدرتها على تكوين أحماض قوية تغير درجة الحموضة بينما في المياه السطحية ، يسبب الفوسفات التخثث.

              </p>
              <h5   dir="rtl" lang="ar">النفايات الصلبة
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"     >
            تشمل النفايات الصلبة الصناعية الناتجة عن إنتاج المنسوجات ما يلي:

              </p>
              <ul className="dot-list"   dir="rtl" lang="ar">
                <li>الرماد والحمأة ،
</li>
                <li>
                صناديق من الورق المقوى ، فيلم تغليف بالة أو قماش متسخ غير قابل لإعادة التدوير ،

                </li>
                <li>أكياس بلاستيكية تحمل المواد الخام الكيميائية ،
</li>
                <li>المخاريط والأنابيب الورقية غير القابلة لإعادة الاستخدام ،
</li>
                <li>
                نفايات الأقمشة والخيوط والألياف الناتجة عن المعالجة غير القابلة لإعادة التدوير.

                </li>
              </ul>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
              من المرجح أن يتم إلقاء النفايات الصلبة غير المدارة كمكب للنفايات.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
          تستهلك صناعات النسيج والأحذية كميات كبيرة من المياه وتهدد أيضا جودة المياه في الصين. أحدث معيار التفريغ ، GB 42872012 ، بمثابة وسيلة لإنفاذ قانون حماية البيئة في الصين ، وتشجيع تحسين أساليب الإنتاج المستخدمة في صناعة صباغة المنسوجات والتشطيب وتحسين تكنولوجيا مكافحة التلوث. تغطي المواصفة القياسية حدود التصريف ، ومتطلبات المراقبة والتحكم في ملوثات المياه في صناعة صباغة المنسوجات والتشطيب أو منشأة الإنتاج.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
         يجب على الصناعات اتباع متطلبات تصريف التلوث والتحكم فيه في المعيار وتكييف التدابير اللازمة لضمان التشغيل العادي لأنظمة مكافحة التلوث. من 1 يناير 2013 إلى 31 ديسمبر 2014 ، كان من المفترض أن تفي المصانع الحالية وجميع المصانع الجديدة بحدود التصريف المقترحة لملوثات المياه. اعتبارا من 1 يناير 2015 ، يجب أن تفي المصانع الحالية بحدود التصريف التي وضعتها CEPL. أصدرت وزارة حماية البيئة (MEP) في جمهورية الصين الشعبية قائمة تعديلات ل GB 42872012 الحالية في 27 مارس 2015 (Louann ، 2015).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
 في الهند ، أمرت هيئة دائرة المحكمة الخضراء الوطنية (NGT) في جودبور بإغلاق 739 وحدة نسيج في بالوترا والمناطق المحيطة بها في جاسول وبيثوجا (ولاية راجستان) حتى 9 يوليو 2015. كما أمرت الصندوق الذي يدير محطة معالجة النفايات السائلة المشتركة (CETP) بتجديد الموافقة على تشغيل المصنع والحصول على إذن التخلص من النفايات الخطرة من مجلس مكافحة التلوث بولاية راجستان. ويزعم أن الوحدات تقوم فيما بينها بتصريف 17-18 مليون لتر من النفايات السائلة غير المعالجة يوميا في نهر درافياواتي. أمرت المحاكم المحلية بإغلاق 213 وحدة بحلول 31 مايو 2015 والباقي بحلول 30 يونيو 2015 مع مطالبة الشرطة المحلية بدعم الأمر (ماثيوز ، 2015).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
            في عام 2012 ، جاء أكثر من نصف صادرات الهند من المنسوجات إلى الولايات المتحدة بقيمة 1.25 مليار دولار من مدينة تيروبور الجنوبية. في حين أن الأعمال التجارية قد جلبت فوائد اقتصادية ، فإن تكاليفها البيئية والاجتماعية كثيرة. في اتجاه مجرى تيروبور وأكثر من 300 مصنع للنسيج ، أصبح نهر نويال رغويا وتغير لونه. ويلقى باللوم على التلوث الناجم عن هذه الصناعة في التسبب في المرض بين السكان المحليين وإضعاف إنتاجية المزارع القريبة.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
        تيروبور ليست حالة معزولة. وفقا للبنك الدولي ، فإن 20٪ من تلوث المياه على مستوى العالم ناتج عن معالجة المنسوجات. وتقول المنظمات غير الحكومية مثل الجماعات البيئية إن أجزاء من الهند والصين من بين أكثر المناطق تلوثا.
              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
           تستجيب الشركات الكيميائية الكبرى وكذلك الشركات الناشئة من خلال تطوير مواد كيميائية أقل ضررا لمعالجة المنسوجات. لكن هذه المواد غالبا ما تكون أغلى من تلك المستخدمة. ويقول المسؤولون التنفيذيون في كيماويات النسيج إن هناك حاجة إلى كواشف منخفضة التكلفة وإنفاذ أفضل من قبل المنظمين ، إلى جانب تحول في سلوك المستهلك بعيدا عن اختيار أرخص المنتجات.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
             تستخدم صناعة النسيج أكثر من 8000 مادة كيميائية لصنع 400 مليار م 2 من الأقمشة التي تباع سنويا في جميع أنحاء العالم. كثير منها سام ويستمر في البيئة. وهي تشمل الأصباغ الغنية بالمعادن الثقيلة وعوامل التثبيت والمبيضات والمذيبات والمنظفات.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
            صناعة المنسوجات هي أيضا عمل كثيف الاستخدام للمياه. يتطلب إنتاج زوج من الجينز حوالي 1800 جالون من الماء. تي شيرت يأخذ 700 جالون. إن معالجة مثل هذه الكميات الكبيرة من مياه الصرف الصحي مكلفة - إذا تمت معالجتها على الإطلاق.

              </p>
              <h5   dir="rtl" lang="ar">انبعاثات الهواء
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
             يساهم الوقود الأحفوري المحترق في انبعاثات ثاني أكسيد الكربون ، وهو مساهم أساسي في ظاهرة الاحتباس الحراري. صناعة النسيج مسؤولة أيضا عن الانبعاثات التالية:

              </p>
              <ul className="dot-list"   dir="rtl" lang="ar">
                <li>
                أكاسيد النيتروجين وأكاسيد الكبريت (من المراجل التي تعمل بالوقود الأحفوري) والتي تخلق حموضة في البيئة الطبيعية (بحيرات المياه العذبة والأنهار والغابات والتربة) وتؤدي إلى تدهور المعادن وهياكل المباني. كما أنها تساهم في تكوين الضباب الدخاني في المناطق الحضرية.

                </li>
                <li>
                تسرب المذيبات إلى الهواء من أفران التجفيف المستخدمة في عمليات طلاء المذيبات.

                </li>
                <li>
                المذيبات المنبعثة من أنشطة التنظيف (تنظيف المرافق العامة وصيانتها ، تنظيف شاشة الطباعة).

                </li>
                <li>
                انبعاثات الهيدروكربونات المتطايرة التي تشمل الهيدروكربونات غير الميثان (NMHC) والهيدروكربونات الهيدروكربونية المؤكسجة (مثل الكحوليات والألدهيدات والأحماض العضوية).

                </li>
              </ul>
              <h5   dir="rtl" lang="ar">5. النقل</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"   >
           والنقل لمسافات طويلة مطلوب لنقل المنتجات النهائية من المصانع الواقعة في البلدان المنخفضة التكلفة للعمالة إلى المستهلك في بلد متقدم، مما يضيف إلى الكمية الإجمالية للوقود غير المتجدد المستهلك.

              </p>
              <h5   dir="rtl" lang="ar">6. مواد التعبئة والتغليف
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
              التعبئة والتغليف هي العلم والفن والتكنولوجيا لإحاطة أو حماية المنتجات للتوزيع والتخزين والبيع والاستخدام. يشير التغليف أيضا إلى عملية تصميم وتقييم وإنتاج العبوات. يمكن وصف التغليف بأنه نظام منسق لإعداد البضائع للنقل والتخزين والخدمات اللوجستية والبيع والاستخدام النهائي. تحتوي العبوة على وتحمي وتحفظ وتنقل وتبلغ وتبيع (سوروكا ، 2002). بالنسبة لتغليف المستهلك ، العبوة المستخدمة لتقديم المنتجات في المتاجر ، والمواد المستخدمة غالبا هي البلاستيك والورق والمعادن والألمنيوم والقطن والقنب والمواد القابلة للتحلل. تعمل الشركات التي تنفذ إجراءات صديقة للبيئة على تقليل بصمتها الكربونية باستخدام المزيد من المواد المعاد تدويرها ، وإعادة استخدام مكونات التغليف بشكل متزايد لأغراض أو منتجات أخرى ، واستخدام المواد المعاد تدويرها (مثل الورق والقطن والجوت والقنب والخشب) والمواد القابلة للتحلل الحيوي والمنتجات الطبيعية المزروعة دون استخدام المبيدات الحشرية أو الأسمدة الاصطناعية والمواد القابلة لإعادة الاستخدام (مثل الأكياس القطنية أو القنب). يعد تقليل نفايات التغليف أحد أفضل الطرق لتقليل التأثير البيئي. يحدد توجيه الاتحاد الأوروبي 94/62 / EC عددا من المتطلبات ذات الصلة بنفايات التعبئة والتغليف والتغليف. كما أنه يحدد أهدافا محددة لإعادة التدوير ومستويات قصوى للمعادن الثقيلة (Tufekci et al.، 1998). التغليف المستدام هو تطوير واستخدام التغليف الذي يؤدي إلى تحسين الاستدامة. في المرحلة النهائية من التصميم ، ينطوي على زيادة استخدام جرد دورة الحياة (LCI) وتقييم دورة الحياة (LCA) الذي يأخذ في الاعتبار مدخلات ومخرجات المواد والطاقة للحزمة ، والمنتج المعبأ (المحتويات) ، وعملية التعبئة ، ونظام الخدمات اللوجستية (Zabaniotou and Kassidi ، 2003).

              </p>
              <h5   dir="rtl" lang="ar">تحسين الاستدامة:
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
              يمكن تحسين استدامة معالجة المنسوجات بعدة طرق مثل:

              </p>
              <ul className="dot-list"   dir="rtl" lang="ar">
                <li>
                استبدال المواد النسيجية والمواد الكيميائية غير المستدامة بمواد عضوية وقابلة للتحلل الحيوي أكثر اخضرارا.

                </li>
                <li>
                القضاء على استخدام المواد الكيميائية السامة في الإنتاج والتعبئة أو التقليل منه إلى أدنى حد

                </li>
                <li>
                التقليل من استخدام المياه والمواد الكيميائية وإعادة تدويرها.

                </li>
                <li>
                تقليل استهلاك الطاقة والوقود في الإنتاج والنقل.

                </li>
                <li>تقليل النفايات وسهولة التخلص منها.
</li>
                <li>الحفاظ على أنظمة الإدارة البيئية بدقة.
</li>
              </ul>
              <h5   dir="rtl" lang="ar">مواد نسيجية أكثر اخضرارا:
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
              المواد الخام الأساسية لصناعة المنسوجات هي ألياف النسيج التي هي من نوعين - الطبيعية والاصطناعية (فارينجتون ، 2008). الألياف الطبيعية الرئيسية هي من أصل نباتي أو حيواني. فهي ليست خضراء بطبيعتها. إنها قابلة للتحلل ، ولكن يمكن صنع المزيد من البوليمرات القابلة للتحلل بالوسائل البيولوجية. يمكن العثور على فرق محدد رئيسي بين البوليمرات الحيوية والبوليمرات الأخرى في هياكلها. غالبا ما يكون للبوليمرات الحيوية بنية محددة جيدا. في المقابل ، تحتوي معظم البوليمرات الاصطناعية على هياكل أبسط وأكثر عشوائية (أو عشوائية). ألياف البوليمر الاصطناعية غير قابلة للتحلل ، وبالتالي يفضل إعادة تدويرها لتقليل التراكم.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
              بسبب زيادة الوعي بالطبيعة الملوثة لنفايات النسيج السائلة ، تتزايد الضغوط الاجتماعية على وحدات معالجة النسيج. أصبح الوعي حول الصداقة البيئية في منسوجات الملابس أحد القضايا المهمة في الآونة الأخيرة. نظرا لمطالب المستهلكين العالميين ، يتم إجراء البحوث لإنشاء تكنولوجيا جديدة صديقة للبيئة. أدت المشاكل المتعلقة بالسمية والمخاطر الصحية الأخرى إلى استبدال المعالجة الكيميائية بطرق فيزيائية أكثر صداقة للبيئة (معهد النسيج ، 2002). فالبلازما، والتكنولوجيا الأحيائية، والمعالجة بالموجات فوق الصوتية، وثاني أكسيد الكربون الفائق الحرجة، وتكنولوجيات الليزر على سبيل المثال، هي تكنولوجيات تكتسب أرضية لأنها توفر العديد من المزايا ضد التقنيات الرطبة التي تحتوي على عدد أقل من المواد الكيميائية الضارة أو لا تحتوي على أي مواد كيميائية ضارة في العمليات الرطبة أو مياه الصرف الصحي (على الرغم من أنه قد لا يزال هناك بعض التلوث؛ فالمعالجة بالبلازما، على سبيل المثال، يمكن أن تؤدي إلى بعض ملوثات الهواء من تدهور أسطح الألياف).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
        يمكن استخدام الألياف النباتية والمواد الكيميائية الصديقة للبيئة لتصنيع المركبات الخضراء.  من بين الألياف الطبيعية ، يتم قبول ألياف اللحاء ، المستخرجة من سيقان النباتات مثل الجوت والكناف والكتان والرامي والقنب على نطاق واسع كأفضل المرشحين لمكونات التعزيز للمركبات بسبب خصائصها الميكانيكية الجيدة ، مع إظهار أن القنب له وعد خاص (Kolybaba et al. ، 2003).

              </p>
              <h5   dir="rtl" lang="ar">قطن عضوي
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
              إنتاج القطن العضوي أكثر ملاءمة للبيئة ، وأفضل لصحة المجتمع والاقتصاد المحلي من القطن المعدل وراثيا. القطن العضوي هو قطن من نباتات غير معدلة وراثيا ومعتمدة للزراعة دون استخدام أي مواد كيميائية زراعية اصطناعية ، مثل الأسمدة أو المبيدات الحشرية أو المواد المزيلة للأوراق ، يتم إنتاجها وفقا لمعايير الزراعة العضوية المعترف بها دوليا

              </p>
              <h5   dir="rtl" lang="ar">الكتان العضوي
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
             يعد نبات الكتان (Linum usitatissimum) أحد أقدم محاصيل الألياف في العالم وقد استخدم في إنتاج الكتان لأكثر من 5000 عام.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
              يشير الكتان العضوي إلى الكتان المصنوع من ألياف الكتان المزروعة دون استخدام مبيدات الآفات السامة أو الأسمدة الكيماوية.

              </p>
              <h5   dir="rtl" lang="ar">الصوف العضوي
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
             متطلبات الحصول على شهادة الصوف العضوي من قبل جمعية التجارة العضوية (OTA) في أمريكا الشمالية هي كما يلي (OTA ، 2011):

              </p>
              <ul className="dot-list"   dir="rtl" lang="ar">
                <li>
                يجب أن تكون علف الماشية والأعلاف المستخدمة من الثلث الأخير من الحمل عضوية معتمدة.

                </li>
                <li>
                يحظر استخدام الهرمونات الاصطناعية والهندسة الوراثية.

                </li>
                <li>
                يحظر استخدام المبيدات الاصطناعية (الداخلية والخارجية والمراعي).

                </li>
                <li>
                يجب على المنتجين تشجيع صحة الماشية من خلال الممارسات الثقافية والإدارية الجيدة.

                </li>
              </ul>
              <h5   dir="rtl" lang="ar">الحرير العضوي
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
             يجب ألا يتم الحصول على الحرير العضوي فقط عن طريق تغذية ديدان القز بأوراق شجيرات التوت التي نمت عضويا ، ولكن لم يتم استخدام "القسوة" فيها (أي ليس بطريقة الإنتاج التقليدية لوضع الشرانق التي تحتوي على ديدان الحرير الحية في الماء المغلي). وهكذا ، في ما يسمى بأصناف "السلام" أو "النباتية" ، يسمح لديدان القز بالتطور والظهور كعث. نتيجة لذلك ، يتم الحصول على الحرير على شكل دبابيس قصيرة بدلا من خيوط مستمرة ، مما ينتج عنه نسيج بمظهر ومقبض مختلفين ، ولكن بمقبض أكثر دفئا. بالنسبة للحرير العضوي ، يتم إعطاء ديدان القز علفا خاليا من المواد الضارة.

              </p>
              <h5   dir="rtl" lang="ar">ألياف السليلوز المتجددة الخضراء
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
             يتم تصنيع خيوط وألياف السليلوز المجددة مثل حرير الفسكوز والألياف المودالية وألياف كوبرو عن طريق إذابة السليلوز في ثاني كبريتيد الكربون في حالة ألياف الفسكوز والمودال ومذيب هيدروكسيد الكوبرامونيوم لألياف كوبرو متبوعا بالترسيب في شكل خيوط في محلول مناسب (عادة حمض معدني). كلا المذيبين يسببان مشاكل بيئية ، وبالتالي ، بذلت محاولات لتطوير عملية بديلة. يتم إنتاج ألياف الليوسيل عن طريق تجديد السليلوز في مذيب عضوي ، هيدرات N-methylmorpholine-N-oxide (NMMO) ، وهي غير سامة وقابلة للتحلل البيولوجي ويتم إعادة تدويرها بالكامل تقريبا (Albrecht et al. ، 1997). دورة حياة ألياف الليوسيل لها تأثير بيئي ضئيل وهي أكثر استدامة بكثير من الألياف الاصطناعية المشتقة من الزيت (مثل البوليستر والنايلون والأكريليك وما إلى ذلك) أو الألياف الطبيعية مثل القطن ، باستخدام مساحة أقل من الأرض أو الري أو المبيدات الحشرية أو الأسمدة لزراعة أشجار الأوكالبتوس أو الزان التي تصنع منها ألياف الليوسيل إذا كانت الغابات تدار بشكل مستدام مما هو عليه الحال بالنسبة للقطن (White et al. ،  2005). تتوفر ألياف Lyocell مثل Tencel (Lenzing ، النمسا) و LyoCell (Lenzing ، النمسا) و NewCell (Akzo-Nobel ، ألمانيا) ؛ 98٪ من إنتاج ألياف الليوسيل يعزى إلى Lenzing.

              </p>
              <h5   dir="rtl" lang="ar">ألياف البوليمر الاصطناعية
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
          يتم استخدام كمية كبيرة من حمض الأديبيك (HOOC (CH2) 4COOH) في إنتاج النايلون 66 والبولي يوريثان ومواد التشحيم والملدنات. تقليديا يتم إنتاجه من البنزين (مادة مسرطنة معروفة).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
             ومع ذلك ، يمكن تحويل الجلوكوز الطبيعي إلى حمض الأديبيك بواسطة إنزيم تم اكتشافه في البكتيريا المعدلة وراثيا.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
            وتنتج بوليمرات البولي يوريثين حاليا من ثنائي أيزوسيانات سامة، ولكن يمكن تصنيع سلسلة من البولي يوريثان القائمة على ثنائيات - كربامات باستخدام إنزيم الليباز B من المبيضات في أنتاركتيكا كعامل حفاز (McCabe، 2004).

              </p>
              <h5   dir="rtl" lang="ar">عمليات تحضيرية أكثر اخضرارا:
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar">
             المواد النسيجية تمتلك مجموعة متنوعة من الشوائب. يجب إزالة كل هذه الشوائب قبل عمليات الصباغة أو الطباعة عن طريق العمليات التحضيرية (أو المعالجة المسبقة) ، والتي قد تختلف من ألياف إلى أخرى.

              </p>
              <h5   dir="rtl" lang="ar">معالجة الانزيم
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
           أهم تطبيق للكيمياء الخضراء في العمليات التحضيرية للنسيج هو استخدام الإنزيمات. الإنزيمات عوامل حفازة حيوية. وهي تتكون من بروتينات معقدة ثلاثية الأبعاد تتكون من سلاسل عديد الببتيد. وهي تتراوح من البروتينات الفردية ذات الكتلة الجزيئية النسبية (RMM) التي تبلغ حوالي 13000 التي تحفز تفاعلا واحدا ، إلى مجمعات الإنزيمات المتعددة. بالإضافة إلى ذلك، تتطلب بعض الإنزيمات بعض الجزيئات الصغيرة غير البروتينية المحددة، المعروفة باسم العوامل المساعدة، لكي تعمل كعوامل حفازة. الإنزيمات هي مواد هشة نسبيا وهي عرضة للتمسخ ، أي التدهور بسبب درجة الحرارة والإشعاع المؤين والضوء والأحماض والقلويات والعوامل البيولوجية وبالتالي تصبح غير نشطة.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"   >
         يتم الحصول على الإنزيمات تجاريا من ثلاثة مصادر أساسية: الأنسجة الحيوانية والنباتات والميكروبات. الإنزيمات الطبيعية ليست متاحة بسهولة بكميات كافية للاستخدام الصناعي. يتم تصنيعها إلى حد كبير عن طريق التخمير ، وهذه التقنية معروفة جيدا لأكثر من 3000 عام. الكائنات الحية الدقيقة المنتجة للإنزيمات المهمة لصناعة النسيج مدرجة في الجدول 1 (شيخ ، 2010).

              </p>
              <h5   dir="rtl" lang="ar">إزالة الحيوية
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
              تتكون أحجام الاعوجاج في الغالب من النشا أو النشا المعدل أو البوليمرات العضوية مثل كحول البولي فينيل (PVA) والبولي أكريلات. تقليديا ، يتم إزالة النشا عن طريق التحلل المائي بالماء أو الأحماض المعدنية أو الأكسدة باستخدام بروميت الصوديوم أو مركبات البيروكس. الطريقة البديلة الصديقة للبيئة هي التعامل مع إنزيمات الأميليز في وجود أو عدم وجود الليباز (لإزالة الدهون). يتم الحصول على إنزيمات الأميليز بشكل رئيسي من مصادر الشعير أو البكتيريا أو البنكرياس في بعض الأحيان.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
            كانت الأميليز أول وأنجح الإنزيمات المستخدمة في صناعة النسيج لإزالة التحجيم. تم استخدامها لأول مرة في أوائل أواخر القرن التاسع عشر عندما تم تطبيق مقتطفات الشعير من الشعير التي تحتوي على الإنزيمات النشطة على أقمشة greige. في عام 1917 تم عزل الإنزيمات البكتيرية وأصبحت البكتيريا في نهاية المطاف مصدرا للإنتاج الصناعي.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
          يمكن تطبيق الأميليز العادي عند درجة الحموضة 5.5-7.0 وعند درجة حرارة 25-55 0C. يمكن استخدام الأميليز للاستخدام في درجة حرارة متوسطة في حدود 50-95 0C ، في حين يمكن استخدام الأميليز بدرجة حرارة عالية بنجاح فوق 95 0C وأيضا في عملية بخار الوسادة. المنتجات النهائية لعملية إزالة الأنزيمات هي أنواع مختلفة من السكريات والدكسترين غير السامة. ومع ذلك ، فإن لها تأثيرا سلبيا على BOD لمياه الصرف الصحي.

              </p>
              <h5   dir="rtl" lang="ar">التنظيف الحيوي
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
         التنظيف هو عملية تنظيف قلوية للألياف الخام (طبيعية في الغالب) قبل عملية التلوين. يحتوي التنظيف الحيوي على عدد من المزايا المحتملة مقارنة بالتنظيف التقليدي. يتم إجراؤه عند درجة حموضة محايدة ، مما يقلل من إجمالي استهلاك المياه ، وتحتفظ الخيوط / الأقمشة المعالجة بخصائص قوتها ، ويتم تقليل فقدان الوزن أو الحد منه مقارنة بالمعالجة بالطرق التقليدية ، ويزيد من نعومة ألياف القطن. درجة حرارة التنظيف الحيوي أقل بكثير مقارنة بالتنظيف الكلاسيكي. درجة الحرارة المثلى هي من 40 إلى 60 درجة مئوية. يمكن أن يخلق التنظيف الحيوي المحبة للماء المطلوبة في نسيج القطن ، ولكن في نفس الوقت يترك مواد شمعية كافية على سطح القماش لتقليل الإضافة المطلوبة للملينات لرضا المستهلك.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
       تم عزل البكتيناز القلوي القوي للغاية مؤخرا. الفائدة الرئيسية لهذا الإنزيم في التحضير الحيوي هي أن الإنزيم لا يدمر السليلوز من ألياف القطن. الإنزيم عبارة عن لياز بكتات ، وعلى هذا النحو يحفز بسرعة كبيرة التحلل المائي لأملاح الأحماض متعددة المجرات (البكتين) في مصفوفة الجدار الأساسي. البكتيناز ، كما يوحي الاسم ، يتحلل البكتين الموجود في القطن كشوائب غير السليلوزية. أفضل أنواع البكتيناز هي تلك التي يمكن أن تعمل في ظل ظروف قلوية قليلا حتى في وجود عوامل مخلبة. وتسمى هذه الإنزيمات "البكتيناز القلوية". عادة ما تكون معظم البكتينازات التقليدية غير نشطة في ظل هذه الظروف المفيدة تجاريا ، ونشاطها الأمثل يكمن في المنطقة الحمضية قليلا (Sundar et al. ، 2007).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
              السليولاز مناسبة بشكل خاص لتنظيف الأقمشة القطنية. تحتوي بعض مستحضرات إنزيم البكتيناز على السليولاز. ثم تتم إزالة هذه الشوائب عن طريق الغسيل اللاحق. ومع ذلك ، فإن الإجراءات المشتركة لكلا النوعين تعطي خسارة أكبر في الوزن وفقدان القوة مقارنة بعمل البكتيناز أو الليباز وحده.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
              يمكن معالجة ألياف القطن ، أو خلطاتها مع الألياف الأخرى ، بمحاليل مائية تحتوي على البروتوبيكتيناز لمدة 18 ساعة عند 40 درجة مئوية لإعطاء خيوط مجوفة مع الاحتفاظ بقوة شد جيدة.  البكتيناز والسليولاز فعالة جدا مقارنة بالبروتياز والليباز.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"     >
           قد يحتوي نظام الإنزيم المشترك للإزالة والتجول في وقت واحد على إنزيمات الأميليز والليباز والبكتيناز لتحقيق خصائص النسيج الضرورية دون استخدام مواد كيميائية قاسية (Karmakar ، 1998).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
         BioPrep 3000L (نوفو نورديسك ، الدنمارك) هو بكتيناز قلوي ، خال من السليولاز (لانج ، 2000). إنه يعمل على النحو الأمثل عند درجة الحموضة 7-9.5 وفي درجة حرارة تصل إلى 60 0 درجة مئوية في أنظمة العادم وفي درجة حرارة أعلى إلى حد ما في أنظمة الوسادة. الطلب على الأكسجين البيولوجي (BOD) والطلب على الأكسجين الكيميائي (COD) لعملية التنظيف الأنزيمي هي 20-45٪ مقارنة بالتنظيف القلوي (100٪). إجمالي المواد الصلبة الذائبة (TDS) لعملية التنظيف الأنزيمي هو 20-50٪ مقارنة بالتنظيف القلوي (100٪). المقبض ناعم جدا في التنظيف الأنزيمي مقارنة بالشعور القاسي في عملية التنظيف القلوية.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
              يتيح التنظيف الأنزيمي تنظيف النسيج بشكل فعال دون التأثير سلبا على النسيج أو البيئة. كما أنه يقلل من المخاطر الصحية بقدر ما لا يتعرض المشغلون للمواد الكيميائية العدوانية (Pawar et al. ، 2002).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"   >
             على الرغم من كل الأبحاث حول bioscuring ، فإنه لم يتم تطبيقه بعد على نطاق صناعي. هناك حاجة إلى البكتيناز مع ارتفاع النشاط والاستقرار في درجات الحرارة العالية والظروف القلوية.

              </p>
              <h5   dir="rtl" lang="ar">التبييض الحيوي
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
              في جامعة أوبورن (الولايات المتحدة الأمريكية) إنزيم أوكسيديز الجلوكوز (GOx; EC 1.1.3.4) للتبييض عندما تم تحسين مؤشر البياض مع فقدان قوة أقل (شيخ ، 2010).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
      في وجود الأكسجين الجزيئي ، يتأكسد الجلوكوز بواسطة إنزيم الجلوكوز أوكسيديز إلى حمض الجلوكونيك وبيروكسيد الهيدروجين. يعمل حمض D-Gluconic كعامل عزل أثناء التبييض. الأميلوغلوكوزيداز والبكتيناز وأوكسيديز الجلوكوز متوافقة فيما يتعلق بدرجة الحموضة النشطة ونطاق درجة الحرارة وتم اختيارها. أظهر مزيج من خطوتين أو ثلاث خطوات تحضير مع الحد الأدنى من كميات حمامات المعالجة وماء الشطف نتائج متوافقة في البياض والامتصاص وقابلية الصباغة وخصائص الشد للأقمشة المعالجة. أجريت مؤخرا دراسات على التبييض الحيوي للصوف في ظل ظروف مؤكسدة واختزالية. أظهرت الدراسات أن تبييض بيروكسيد الهيدروجين في وجود مستحضر الأنزيم البروتيني ، Bactosol SI (Clariant) ، حسن بشكل كبير البياض والماء.

              </p>
              <h5   dir="rtl" lang="ar">بيروكسيد القاتل
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
          يحفز الكاتالاز (CATs) ، بشكل صحيح هيدروبيروكسيداز ، تدهور H2O2 إلى H2O و O2. الكاتلاز أو البيروكسيديز هو فئة مؤكسدة من الإنزيم تنتجها مجموعة متنوعة من الكائنات الحية الدقيقة المختلفة بما في ذلك البكتيريا والفطريات (Mueller et al. ، 1997) ومعظمها يحتوي على أوبتيما في درجات حرارة معتدلة (20-50 درجة مئوية) ودرجة حموضة محايدة. بالإضافة إلى الجزء البروتيني من الجزيء ، يحتوي إنزيم الكاتلاز على جزء غير بروتيني ، وهو مشتق من الهيام ويتضمن الحديد المعدني. ميزة إنزيم الكاتلاز (جنسن ، 2000). هو أنه يهاجم بيروكسيد الهيدروجين فقط ولا شيء غير ذلك. رد الفعل هو كما يلي:

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
              H2O2 + كاتلاز → 2H2O + O2 + كاتلاز [22.4]

              </p>
              <h5   dir="rtl" lang="ar">لاكاكيس</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"   >
            Laccases هي مجموعة من الإنزيمات المؤكسدة التي تم إهمال استغلالها كمحفزات حيوية في التخليق العضوي في الماضي ، ربما لأنها لم تكن متاحة تجاريا بسهولة. إنها بروتينات سكرية ، تم الإبلاغ عن وجودها في النباتات العليا وفي كل الفطريات التي تم فحصها تقريبا (Barreca A.M. et al. 2003). Laccases هي oxidoreductases (EC 1.10.3.2 ، p-diphenol: ثنائي أوكسيجين أوكسيدوريدوكتاز) تنتمي إلى ما يسمى عائلة النحاس الأزرق من أوكسيديز (ريفا ، 2006) ، أوكسيديز متعدد النواة يحتوي على النحاس. أنها تحفز الأكسدة الإلكترونية الأحادية للركائز على حساب الأكسجين الجزيئي.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
            في الوقت الحاضر ، التطبيقات التكنولوجية الرئيسية لل laccases هي في صباغة المنسوجات أو صناعات الطباعة ، في العمليات المتعلقة بإزالة لون الأصباغ (Li et al. ، 1999) - وفي صناعات اللب والورق لإزالة الألياف الخشبية ، لا سيما أثناء عملية التبييض (Galante ، and Formantici. 2003). في معظم هذه التطبيقات ، يتم استخدام laccases مع وسيط كيميائي.

              </p>
              <h5   dir="rtl" lang="ar">الملونات</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"   >
            مجموعات الآزو (-N = N-) ، مثل تلك المدمجة في مركبات البنزينويد ، والتي تشكل أساس غالبية الأصباغ الاصطناعية ، لا توجد في المنتجات التي تحدث بشكل طبيعي. ما يقرب من 70 ٪ من جميع الأصباغ (التي تنتمي إلى فئات الأصباغ المختلفة) المستخدمة في صناعة النسيج هي أصباغ الآزو (Carliell et al. ، 1995). في ظل الظروف الاختزالية ، قد تنتج بعض أصباغ الآزو أمينات مسرطنة (Lacasse and Baumann ، 2004).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
      بعد إدخال قانون السلع الاستهلاكية الألماني في عام 1994 الذي قيد استخدام بعض أصباغ الآزو في السلع الاستهلاكية ، قدمت العديد من الدول الأعضاء الأخرى في الاتحاد الأوروبي لوائح مماثلة ولكنها مختلفة (EC ، 2002). يصنف عدد صغير من الأمينات العطرية على أنها مسرطنة أو يحتمل أن تكون مسرطنة للبشر ، وبالتالي ، من أجل حماية صحة الإنسان ، تم حظر استخدام أصباغ الآزو التي يمكن أن تتحلل في ظل ظروف اختزالية لإطلاق أي من مجموعة من الأمينات العطرية المحددة ، في السلع الاستهلاكية التي تعتبر ملامسة منتظمة للجلد.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
              وأربعة أمينات مسرطنة محظورة هي: (أ) 4-أمينوثنائي الفينيل؛ و (ب) 4-أمينو ثنائي الفينيل؛ و (ب) 4-أمينو ثنائي الفينيل؛ و (ب) (ب) البنزيدين؛ (ج) 4-كلورو-O-تولويدين؛ د: 2-نفثيلامين. لا ينبغي اكتشاف الأريلامين القابل للانقسام والمواد المسرطنة والمواد المسببة للحساسية وغيرها من الملونات المحظورة في المواد النهائية أو في الأجزاء المصبوغة منها. يتوفر مزيد من المعلومات في موقع Oeko-tex (Oeko-tex، 2013).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
        قائمة 187 صبغة آزو محظورة (106 أصباغ مباشرة ، 30 صبغة حمضية ، 11 صبغة أساسية ، 11 لون أزويك ، 27 صبغة مشتتة وصبغتان أخريان) من حوالي 2000 متاحة في مكان آخر (EC 2002) ؛ يصعب تحديث هذه القوائم بسبب التطورات الكيميائية الجديدة والتغيرات القطاعية ، ولهذا السبب ، يوصى بالتحقق بشكل دوري من روابط الإنترنت (Oeko-tex ، 2013) حيث تتوفر قائمة تحديث الأصباغ المحظورة.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
         نظرا للقضايا البيئية والسمية المعروفة المحيطة باستخدام الكروم والكوبالت ، فقد أجريت أبحاث في استبدالها بمعادن أكثر اعتدالا بيئيا مثل الحديد والألمنيوم. كبدائل صديقة للبيئة للأصباغ الحمضية المعقدة المعدنية Cr (III) و Co (III) ، تم تصنيع مجموعة من أصباغ الفورمازان المعقدة للحديد 1: 2 ، والتي تنتج ظلال بنفسجية وزرقاء وسوداء وبنية على الصوف والبولي أميد مع ثبات جيد للرطوبة والضوء (Carliell et al. ، 1995)

              </p>
              <h5   dir="rtl" lang="ar">الأصباغ التفاعلية
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
            تحظى الأصباغ التفاعلية الخالية من المعادن حاليا بشعبية كبيرة في صباغة المنسوجات وتجارة الطباعة - فهي آمنة نسبيا ولم يتم الإبلاغ عن العديد من الآثار الضارة (Hannemann and Runser 1999). ومع ذلك ، فإن النقص الأكثر وضوحا في الأصباغ التفاعلية التقليدية يكمن في حقيقة أن تثبيت الصبغة على الألياف لا يزيد عن 70٪ حتى في تطبيقات الطباعة. يخضع الجزء المتبقي من الصبغة للتحلل المائي بدلا من التفاعل مع الألياف مما يزيد من حمل التلوث في النفايات السائلة. في الآونة الأخيرة ، تم تطوير أصباغ تفاعلية توفر درجات تثبيت أعلى بكثير من الأصباغ التفاعلية التقليدية (Morris et al. ، 2008).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
             تحتوي هذه الأصباغ التفاعلية عالية التثبيت (أعلى من 90٪) على مجموعات تفاعلية متعددة (معظمها اثنتان) متصلة بكل جزيء صبغة.قد تحتوي الصبغة على مجموعتين تفاعليتين متشابهتين ، أي أصباغ وظيفية متجانسة مثل أصباغ Procion HE® (DyStar) أو مجموعتين تفاعليتين مختلفتين ، أي الأصباغ الوظيفية غير المتجانسة مثل Procion ME® (DyStar).

              </p>
              <h5   dir="rtl" lang="ar">الأصباغ الطبيعية
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
             يمكن وضع الأصباغ الطبيعية في ثلاث فئات على أساس المنشأ - من النباتات (مثل النيلي) ، ومن الحيوانات (مثل القرمزي) ، وتلك التي يتم الحصول عليها من المعادن (مثل المغرة). تم جدولة الأنواع الرئيسية من الأصباغ الطبيعية وأصلها بواسطة Hill (1997).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
               قبل ظهور الأصباغ الاصطناعية ، كانت الأصباغ الطبيعية تستخدم على نطاق واسع ، غالبا مع مواد لاذعة مثل الشب ، لصبغ الألياف الطبيعية مثل الصوف والكتان والقطن والحرير ، لكن استخدامها انخفض بعد اكتشاف الأصباغ الاصطناعية. ومع ذلك ، في السنوات الأخيرة ، تم إحياء الاهتمام بالأصباغ الطبيعية بسبب زيادة الطلب على الشركات المصنعة لإنتاج بدائل أكثر صداقة للبيئة للأصباغ المشتقة من البتروكيماويات. إحدى القضايا الرئيسية المرتبطة باستخدام الأصباغ الطبيعية في تلوين المنسوجات هي ضعف ثبات الضوء إلى المعتدل ، وعلى الرغم من تقاليدها الطويلة ، ليست كل الأصباغ الطبيعية صديقة للبيئة بشكل خاص. بعض الأصباغ الطبيعية ليس لها تقارب أو قليل من التقارب للمواد النسيجية وتتطلب أملاح المعادن الثقيلة كمواد للتثبيت وثبات الألوان. قد تكون الأصباغ الطبيعية مستدامة ، ولكنها تحتاج إلى الماء والأرض لإنتاجها ولا يوجد ما يكفي من محصول الصبغة لكل فدان من المواد النباتية للحفاظ على الإنتاج على نطاق صناعي.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
         يمكن تصنيف الأصباغ الطبيعية إلى مجموعتين ، اعتمادا على طريقة التطبيق ، وهما الأصباغ الموضوعية وغير الموضوعية. لا تتطلب الأصباغ الموضوعية معالجة مسبقة للنسيج (مثل النيلي والأورشيل والكركم) وهناك ثلاثة أنواع: مباشرة (للقطن ، مثل الكركم والقرطم ؛ حمض (للحرير والصوف ، مثل الزعفران ، لاك) أو أساسي (للحرير والصوف ، مثل البربارين). على النقيض من ذلك ، يمكن للأصباغ غير الموضوعية أن تصبغ فقط المواد التي تم تغذيتها بالفعل أو تعمل مع إضافة مادة لاذعة إلى حمام الصباغة (مثل خشب الخشب ، الفوة / الأليزارين ، القرمزي أو المصهر)

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
            عوامل التثبيت الموصى بها هي الشب وكلوريد ستانوس وحمض الطرطريك وكبريتات الحديدوز وزيت الديك الرومي الأحمر. تستخدم العفص كمواد طبيعية في عملية الصباغة الطبيعية ، لأنها يمكن أن تعزز تقارب الأصباغ المختلفة. العفص هي مركبات فينولية تحدث بشكل طبيعي وتلك التي تحتوي على مجموعات o-dihydroxy تشكل مخلبات معدنية بعد المعالجة المسبقة أو المعالجة اللاحقة للركيزة بأملاح معدنية. يمكن اعتبار تركيبات ملح معدن التانين ، بدلا من العفص نفسها ، بمثابة مادة للأصباغ الطبيعية. بعض المواد الخام الهامة للعفص هي لحاء البلوط والخشب (Quercus infectoria) ، قشرة الرمان (Punica granatum) و cutch (أكاسيا كاتيشو) (روي تشودري ، 2006).

              </p>
              <h5   dir="rtl" lang="ar">عمليات صباغة أكثر اخضرارا:
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
             لكي تصبح الصباغون مسؤولة بيئيا ، يحتاجون إلى اعتماد مبادئ "3R" الراسخة لمنع التلوث ، أي التقليل وإعادة الاستخدام وإعادة التدوير. أكثر ممارسات منع التلوث فعالية في معالجة المنسوجات الرطبة هي الصباغة "الصحيحة لأول مرة". تستهلك التدابير التصحيحية مثل إضافات التظليل ، أو عمليات التجريد وإعادة الصباغة ، أصباغا ومواد كيميائية إضافية ومياه وطاقة (هولمز ، 2012).
              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
             هناك نهجان أساسيان لمكافحة التلوث:

              </p>
              <ul className="dot-list"   dir="rtl" lang="ar">
                <li>معالجة النفايات السائلة - أو حلول نهاية الأنبوب
</li>
                <li>تقليل النفايات - أو حلول تقليل المصدر
</li>
              </ul>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"     >
       النهج الأول ليس له مردود مالي في حين أن نهج تقليل النفايات لا يقلل فقط من التأثير البيئي ولكن أيضا يقلل من تكلفة الإنتاج ولديه القدرة على جعل عمليات الصباغة أكثر اخضرارا بعدة طرق:

              </p>
              <ul className="dot-list"   dir="rtl" lang="ar">
                <li>
                يهدف تحسين العملية إلى تقليل وقت العملية واستهلاك الطاقة ، على سبيل المثال ، عن طريق استخدام عمليات التنظيف / الصبغ المدمجة)

                </li>
                <li>
                انخفاض استهلاك المياه (نسبة الخمور المنخفضة للغاية - 3: 1 إلى 4: 1 للبوليستر و 6: 1 للقطن) ، والطاقة الكهربائية واستهلاك البخار.

                </li>
                <li>
                تعزيز الإرهاق العالي ، على سبيل المثال ، من خلال استخدام الأصباغ متعددة الوظائف التفاعلية للألياف والتي يمكن أن تسبب استنفادا يزيد عن 95٪ وبالتالي تقليل التلوث.

                </li>
                <li>
                طرق التحضير والصباغة المستمرة بدلا من طرق الدفعات لتقليل استهلاك الطاقة والمياه والمواد الكيميائية إلى أقل من النصف.

                </li>
                <li>
                عمليات صباغة الوسادة الباردة شبه المستمرة باستخدام الأصباغ التفاعلية بدلا من طرق الدفعات أو بخار الوسادة (Kehry and Strohle ، 2006).

                </li>
                <li>
                معالجة الدنيم الخالية من الماء الخالية من المواد الكيميائية باستخدام تقنية الليزر لحرق سطح قماش الدنيم المصبوغ بسرعة أو زوج من الجينز على عارضة أزياء لتكرار المظهر البالي الأصلي. تقليديا ، يتم ذلك بالحجارة أو العوامل المؤكسدة أو الإنزيمات بالطرق المائية (Tarhan and Sariisik ، 2009).

                </li>
                <li>
                الطباعة الرقمية المستدامة وطباعة نقل الحرارة التي تتطلب كمية أقل بكثير من المياه وتنتج نفايات أقل بكثير من طرق الطباعة التقليدية (Fashion-incubator ، 2010).

                </li>
                <li>
                عملية طباعة النقل البارد (Cooltrans) للأصباغ التفاعلية في درجة حرارة الغرفة على القطن المعالج مسبقا والفسكوز والكتان والحرير وبالتالي توفير الماء والحرارة (Thiry، 2010).

                </li>
                <li>
                صباغة ثاني أكسيد الكربون فوق الحرجة أو الصباغة بدون ماء (Miah et al. ، 2013).

                </li>
              </ul>
              <h5   dir="rtl" lang="ar">الصباغة في ثاني أكسيد الكربون فوق الحرج:
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
             السائل فوق الحرج ، وهو مادة أعلى من درجة حرارته وضغطه فوق الحرج (والتي بالنسبة لثاني أكسيد الكربون فوق الحرج هي 31.1 درجة مئوية و 73.8 بار على التوالي (Cid et al. ، 2005) ، لها خصائص في منتصف الطريق بين الغاز والسائل. عندما يتم ضغط الغاز يصبح كثيفا بشكل متزايد وأخيرا يكون تقريبا بنفس كثافة السائل ، ويتوسع لملء وعاءه مثل الغاز ولكن بكثافة مماثلة لكثافة السائل. حظي التطبيق العملي للسوائل فوق الحرجة كوسائط صباغة باهتمام كبير من الباحثين في العقد الأخير من القرن العشرين ، كما يتضح من المراجعة التي أجراها باخ وزملاؤه (Bach etal ، 2002). كان ثاني أكسيد الكربون حتى الآن الأكثر استخداما ، بسبب النقطة الحرجة المريحة ، والرخص ، والاستقرار الكيميائي ، وعدم القابلية للاشتعال ، والاستقرار في التطبيقات المشعة وعدم السمية. بسبب اللزوجة الصغيرة للفوق الحرجة.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
            ثاني أكسيد الكربون ومعامل الانتشار العالي لجزيئات الصبغ في هذه الحالة ، تتخلل جزيئات الصبغ المشتتة بسهولة الألياف ونتيجة لذلك توفر صباغة ثاني أكسيد الكربون فوق الحرجة نقلا أفضل للصبغ مقارنة بالصباغة في الماء. CO2 المستخدم هو منتج نفايات الاحتراق والتخمير وتوليف الأمونيا ، لذلك لا يلزم إنتاجه خصيصا للصباغة.
              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
             المزايا الرئيسية (Poliakoff and Licence ، 2007) لاستخدام CO2 فوق الحرج (scCO2) بدلا من الماء في عملية الصباغة هي:

              </p>
              <ul className="dot-list"   dir="rtl" lang="ar">
                <li>
                الفصل السهل ل CO2 والصبغة غير المستخدمة المتبقية بعد عملية الصباغة. يؤدي إزالة الضغط إلى ترسيب الصبغة الزائدة ويعطي CO2 نظيفا وغازيا ، بحيث يمكن إعادة تدوير كلا المركبين وعدم توليد أي نفايات.

                </li>
                <li>
                بعد عملية الصباغة ، لا يحتاج النسيج إلى أي خطوة تجفيف كثيفة الاستهلاك للطاقة كما في حالة الصباغة المائية.

                </li>
                <li>
                نظرا لأن scCO2 مذيب غير قطبي ، فلا حاجة إلى عامل تشتيت عند استخدام الأصباغ غير القطبية ، وهي ميزة إضافية ل scCO2 في صباغة البوليستر المشتتة. هذا يعني أنه يمكن استخدام تركيبات صبغة أبسط من صباغة البوليستر المائية حيث يشكل عامل التشتيت حوالي 50٪ من مسحوق الصبغة بالكامل.

                </li>
                <li>
                أحد أسباب الاقتصاد المتفوق للعملية فوق الحرجة على العملية المائية هو ارتفاع معدل الصباغة.

                </li>
              </ul>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"      >
          تضافرت جهود اثنين من رواد الصناعة - Huntsman Textile Effects و DyeCoo Textile Systems - في أكتوبر 2012 لتطوير وتنمية تكنولوجيا معالجة المنسوجات CO2 (scCO2) فوق الحرجة. ويهدف التعاون المشترك إلى إنشاء منتجات أكثر استدامة ستفيد الصناعة ككل. باستخدام ثاني أكسيد الكربون كوسيط للتطبيق ، تقضي تقنية DyeCoo المبتكرة تماما على استخدام الماء في عملية صباغة المنسوجات. تعمل Huntsman Textile Effects مع DyeCoo لتطوير وتقديم منتجات صبغية وكيميائية مبتكرة لدعم عملية الصباغة بدون ماء والحصول على مستوى عال من ثبات اللون والأداء الذي يطلبه المستهلكون. يستخدم DyeCoo غاز scCO2 بدلا من الماء لإضفاء اللون على النسيج. تجبر غرف الضغط الخاصة التي يتم التحكم في درجة حرارتها ثاني أكسيد الكربون على العمل كمائع مشابه للماء (السائل فوق الحرج CO2) مما يؤدي إلى تضخم ألياف البوليمر مما يسمح للصبغة المشتتة بالانتشار بسهولة داخل البوليمر ، واختراق الألياف ، وحمل الأصباغ إلى النسيج والتسبب في صباغة مثالية. البحث جار بالفعل لتطبيق التكنولوجيا على الأقمشة الطبيعية والاصطناعية الأخرى (هانتسمان ، 2016).

              </p>
              <h5   dir="rtl" lang="ar">الاتجاهات المستقبلية:
</h5>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"     >
        يتم استخدام غالبية المواد الكيميائية أثناء المعالجة الرطبة ، مثل الصباغة والغسيل والطباعة وتشطيب الأقمشة. وفقا للدراسات الاستقصائية ، يتم استهلاك ما يصل إلى 200 طن من المياه لكل طن من المنسوجات المنتجة. العديد من المواد الكيميائية المستخدمة في إنتاج المنسوجات غير خطرة ، ولكن نسبة صغيرة نسبيا من هذه المواد الكيميائية يحتمل أن تكون خطرة.

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar" >
          لا يمكن تحقيق الإنتاج والاستهلاك المستدامين إلا إذا أخذ الصناعيون وتجار التجزئة والمستهلكون العوامل البيئية في الاعتبار في كل عملية صنع القرار. كان هناك وعي متزايد بأن العديد من المنتجات يمكن إنتاجها في ظل ظروف أفضل مع احترام أكبر للبيئة ، على سبيل المثال ، باستخدام طاقة أقل ، وتحقيق غلات أفضل ، وخلق تلوث أقل للمياه أو الهواء ، وتوليد نفايات أقل وعدد أقل (أو لا) من المنتجات الثانوية غير المرغوب فيها. توجد الآن مجموعة دولية من المعايير في إطار سلسلة ISO 14000 فيما يتعلق بتقييم وتحسين الإدارة البيئية داخل الصناعة (Boiral ، 2007).

              </p>
              <p
                style={{
                  marginBottom: "17px",
                  lineHeight: "1.7",
                  fontSize: "17px",
                  color: "#666",
                }}
                dir="rtl" lang="ar"  >
          مع استمرار عولمة جزء المعالجة الرطبة في صناعة النسيج ، من الواضح أنه لا يزال هناك مجال لمواصلة "تخضير" عملياتها والكيمياء المعنية. في كل حالة من حالات التلوث تقريبا ، وجد أن المشكلة الأساسية لصناعة النسيج هي انخفاض عدم كفاءة العملية وسوء فهم دورة حياة المواد الكيميائية النسيجية. سيؤدي تطبيق مبادئ الكيمياء الخضراء والجوانب الأخرى للتكنولوجيا النظيفة بشكل متزايد إلى أنظمة تصنيع أكثر توافقا مع البيئة.

              </p>
       
           
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
